import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as styleHelpers } from '../../../assets/style-helpers.scss';

export const templateSummaryPanel = document.createElement('template');

templateSummaryPanel.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styleHelpers}</style>
  <style>${styles}</style>
  <div class="incident-severity-panel">
    <div class="panel-wrapper">
      <div class="score-panel" >
         <div class="score-panel-inner">
            <gz-counter id="summary-counter" target="100"></gz-counter><span class="summary-total">/100</span>
            <gz-title id="score-description" fontSize="11" lineHeight="1.2"></gz-title>
        </div>
      </div>
      <div class="info-panel">
        <gz-tooltip id="created-tooltip">
          <gz-labeled-content labelfontsize="12" id="created" ></gz-labeled-content>
        </gz-tooltip>
        <gz-tooltip id="last-updated-tooltip">
          <gz-labeled-content labelfontsize="12" id="last-updated" ></gz-labeled-content>
        </gz-tooltip>
        <gz-labeled-content labelfontsize="12" id="attack-types" >
          <div id="visible-attack-types-wrapper"></div>
          <div id="other-attack-types-text"> </div>
        </gz-labeled-content>
        <div id="more-attack-types-card-wrapper">
          <div id="more-attack-types-card">
            <gz-icon-button icon="ds-icon-clear"
             id="more-attack-types-close-button"
             size="24"
             font-size="20"
             role="button"
             class="gz-icon-button"
             buttonfill="quiet"
             buttoncolor="secondary"
             >
            </gz-icon-button>
            <gz-title fontSize="16" id="more-attack-types-title"></gz-title>
            <gz-text fontSize="13" id="more-attack-types-list"></gz-text>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="summary-panel">
    <gz-title id="summary-title" fontSize="11" fontWeight="600" ></gz-title>
    <gz-text id="narrative" fontSize="12"></gz-text>
  </div>
  <div class="root-cause-panel">
    <gz-title id="root-cause-title" fontSize="11" fontWeight="600"></gz-title>
    <gz-text id="reasoning" fontSize="12"></gz-text>
  </div>
  <div class="wrapper mb-3"></div>
  <gz-button id="incident-report" type="outline" color="primary" theme="light" buttonheight="small"></gz-button>
  <div class="wrapper">
  </div>
`;
